import * as React from 'react'
import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from '@mui/material'

/**
 * ConfirmDialog component for asking confirmation in a dialog
 */
const ConfirmDialog = ({ open, message, onConfirm, onClose }) => {
  return (
    <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth>
      <DialogTitle>Confirmation</DialogTitle>
      <DialogContent>
        <DialogContentText color="primary">
          {message}
        </DialogContentText>
      </DialogContent>
      <DialogActions sx={{ p: 4, gap: 1 }}>
        <Button variant="contained" color="secondary" onClick={onClose}>
          No
        </Button>
        <Button variant="contained" onClick={onConfirm} autoFocus>
          Yes
        </Button>
      </DialogActions>
    </Dialog>
  )
}

export default ConfirmDialog